export const jobStatusType = {
  INITIAL: 'INITIAL',
  IN_QUEUE: 'IN_QUEUE',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
}

export const MAX_SYSTEM_MESSAGE_WEBHOOKS_PER_ORGANIZATION = 3
export const CUSTOM_RANGE_LIMIT_IN_MONTHS = 6
export const CUSTOM_RANGE_LIMIT_EVENTS = 1

export const MQTT_ONLY_DEVICE_SETTINGS = [
  'virtualIgnition',
  'screenTimeout',
  'wakeupMsg',
  'ledEnabled',
  'recordingIndicator'
]
